import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    fontFamily: 'Inter, sans-serif',
    screenXSMin: 0,
    screenXS: 320,
    screenXSMax: 743,

    screenSMMin: 744,
    screenSM: 744,
    screenSMMax: 1159,

    screenMDMin: 1160,
    screenMD: 1160,
    screenMDMax: 1439,

    screenLGMin: 1440,
    screenLG: 1440,
    screenLGMax: 1919,

    screenXLMin: 1920,
    screenXL: 1920,
    screenXLMax: 2559,

    screenXXLMin: 2560,
    screenXXL: 2560,
  },
  components: {
    DatePicker: {
      fontSize: 16,
    },
    Table: {
      borderColor: '#DFDFDF',
    },
  },
};
